module.exports = __webpack_public_path__ + "assets/img/março-on-fire-restaurantes-feed.dd5505b8.png";